import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import db from "../../firebase";  
import firebase from "firebase/app";
// Material UI components for styling
import Grid from "@material-ui/core/Grid";
import TextField from '@material-ui/core/TextField';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import SendIcon from '@material-ui/icons/Send';

const Compose = ( props ) => {
    let history = useHistory();
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const author = props.username;
    const [featuredImg, setFeaturedImg] = useState("");
    const [article, setArticle] = useState("");
    const [instaLink, setInstaLink] = useState("");
    const [instaArray, setInstaArray] = useState([]);
    const blogsRef = db.collection("blogs");
    const handleMoreLink = (event) => {
        setInstaArray(prevItems => ([...prevItems, instaLink]));
    }
    const handleSubmit = async(event) => {
        event.preventDefault();
        const blog = { 
            title: title, 
            description: description, 
            author: author,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            featuredImg: featuredImg, 
            article: article,
            instaArray: instaArray,
            published: true
        };
        await blogsRef.add(blog);
        console.log("blog added");
        history.push("/admin/posts");
    }

    return (
        <Grid>
            <h1>Hello {props.username}</h1>
            <h1>Compose page</h1>
            {/* Compose the Post */}
            <form className="container" onSubmit={handleSubmit}>
                {/* Title */}
                <TextField 
                    required 
                    fullWidth 
                    id="Title" 
                    label="Title" 
                    variant="filled" 
                    value={title} 
                    onChange={(event) => setTitle(event.target.value)} 
                    helperText="Enter the Title of the post" 
                />
                {/* Description */}
                <TextField 
                    required 
                    fullWidth 
                    id="Description" 
                    label="Description" 
                    variant="filled" 
                    value={description} 
                    onChange={(event) => setDescription(event.target.value)} 
                    helperText="Enter the Description of the post" 
                />
                {/* Featured Image */}
                <TextField 
                    required 
                    fullWidth 
                    id="featuredImg" 
                    label="Featured Image" 
                    variant="filled" 
                    value={featuredImg} 
                    onChange={(event) => setFeaturedImg(event.target.value)} 
                    helperText="Enter the link of the image" 
                />
                <img src= {featuredImg} alt="" />
                {/* Article */}
                <TextField required multiline fullWidth id="filled-basic" label="Article" variant="filled" value={article} onChange={(event) => setArticle(event.target.value)} rows={10} helperText="Enter the post in html format (without the <head> and <body> tags, just the <p> <img> and other tags)" />
                {/* Insta post Carousel images */}
                <TextField fullWidth id="featuredImg" label="Carousel Image link" variant="filled" value={instaLink} onChange={(event) => setInstaLink(event.target.value)} helperText="Enter the link of the Instagram post image" />
                <Button type="button" color="primary" variant="outlined" onClick={handleMoreLink}>Add Image</Button>
                <Grid container direction="row" spacing={1}>
                    {instaArray.map((instaImg, i) => (
                        <Grid item key={i}>
                            <img className="composeInstaImg" key={instaImg} src={instaImg} alt="" />
                        </Grid>))
                    }
                </Grid>
                {/* Submit button */}
                <Divider />
                <Button type="submit" endIcon={<SendIcon />} variant="outlined">
                    Publish
                </Button>
            </form>
        </Grid>
    );
}

export default Compose;